import { render } from "./OmnyDeleteModal.vue?vue&type=template&id=46bcf8d9"
import script from "./OmnyDeleteModal.vue?vue&type=script&lang=js"
export * from "./OmnyDeleteModal.vue?vue&type=script&lang=js"

import "./OmnyDeleteModal.vue?vue&type=style&index=0&id=46bcf8d9&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__